/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anywhere regular expressions are supported: a programming language, a code editor's search, command-line tools like grep, or a sequence search box that accepts regex.`)
};

const es_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cualquier lugar donde se admitan expresiones regulares: un lenguaje de programación, la búsqueda de un editor de código, herramientas de línea de comandos como grep, o un cuadro de búsqueda de secuencias que acepte regex.`)
};

const de_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überall, wo reguläre Ausdrücke unterstützt werden: eine Programmiersprache, die Suche eines Code-Editors, Kommandozeilen-Tools wie grep, oder ein Sequenzsuchfeld, das Regex akzeptiert.`)
};

const nl_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overal waar reguliere expressies worden ondersteund: een programmeertaal, de zoekfunctie van een code-editor, opdrachtregeltools zoals grep, of een sequentiezoekvak dat regex accepteert.`)
};

const fr_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partout où les expressions régulières sont prises en charge : un langage de programmation, la recherche d'un éditeur de code, des outils en ligne de commande comme grep, ou une boîte de recherche de séquences qui accepte les regex.`)
};

const it_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ovunque siano supportate le espressioni regolari: un linguaggio di programmazione, la ricerca di un editor di codice, strumenti a riga di comando come grep, o un campo di ricerca di sequenze che accetta espressioni regolari.`)
};

const pt_br2_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em qualquer lugar em que expressões regulares sejam suportadas: uma linguagem de programação, a busca de um editor de código, ferramentas de linha de comando como grep, ou uma caixa de busca de sequências que aceite regex.`)
};

const pt_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em qualquer sítio onde as expressões regulares sejam suportadas: uma linguagem de programação, a pesquisa de um editor de código, ferramentas de linha de comandos como o grep, ou uma caixa de pesquisa de sequências que aceite regex.`)
};

const ja_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正規表現に対応している場所ならどこでも使えます: プログラミング言語、コードエディタの検索、grepなどのコマンドラインツール、正規表現に対応した配列検索ボックスなどです。`)
};

const zh_iupac_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任何支持正则表达式的地方：编程语言、代码编辑器的搜索功能、grep 等命令行工具，或接受正则表达式的序列搜索框。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_a3", locale)
	if (locale === "en") return en_iupac_faq_a3(inputs)
	if (locale === "es") return es_iupac_faq_a3(inputs)
	if (locale === "de") return de_iupac_faq_a3(inputs)
	if (locale === "nl") return nl_iupac_faq_a3(inputs)
	if (locale === "fr") return fr_iupac_faq_a3(inputs)
	if (locale === "it") return it_iupac_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_a3(inputs)
	if (locale === "pt") return pt_iupac_faq_a3(inputs)
	if (locale === "ja") return ja_iupac_faq_a3(inputs)
	return zh_iupac_faq_a3(inputs)
};